/**
 * Generato automaticamente.
 * framework-cmp-procedimenti
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient.ts';
import type { ErrorType } from '../../../client/apiClient.ts';
import type { AnagraficaFasiDTO } from '../schemas/anagraficaFasiDTO.ts';
import type { GetBackApplicazioniAnagraficaFasiParams } from '../schemas/getBackApplicazioniAnagraficaFasiParams.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * @summary Ricerca delle fasi disponibili per i procedimenti associati al verticale
 */
export const getBackApplicazioniAnagraficaFasi = (
  params?: GetBackApplicazioniAnagraficaFasiParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<AnagraficaFasiDTO[]>(
    {
      url: `/framework-bo-procedimenti/applicazioni/anagrafica-fasi`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetBackApplicazioniAnagraficaFasiQueryKey = (
  params?: GetBackApplicazioniAnagraficaFasiParams,
) =>
  [
    `/framework-bo-procedimenti/applicazioni/anagrafica-fasi`,
    ...(params ? [params] : []),
  ] as const;

export const getGetBackApplicazioniAnagraficaFasiQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackApplicazioniAnagraficaFasi>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBackApplicazioniAnagraficaFasiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackApplicazioniAnagraficaFasi>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackApplicazioniAnagraficaFasi>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackApplicazioniAnagraficaFasiQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackApplicazioniAnagraficaFasi>>
  > = ({ signal }) =>
    getBackApplicazioniAnagraficaFasi(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetBackApplicazioniAnagraficaFasiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackApplicazioniAnagraficaFasi>>
>;
export type GetBackApplicazioniAnagraficaFasiQueryError = ErrorType<unknown>;

/**
 * @summary Ricerca delle fasi disponibili per i procedimenti associati al verticale
 */
export const useGetBackApplicazioniAnagraficaFasi = <
  TData = Awaited<ReturnType<typeof getBackApplicazioniAnagraficaFasi>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBackApplicazioniAnagraficaFasiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackApplicazioniAnagraficaFasi>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackApplicazioniAnagraficaFasiQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
